import type { ContainerType } from '../../../mentions/MentionBase';
import Mention from '../../Mention';

class AnnotationMention extends Mention {
  protected override containerType: ContainerType = 'comment';
}

export default AnnotationMention;
